import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Tyre } from "models";

const component = "DBBTyreSearch";

export const DBBTyreSearchQueryKeys = {
  tyreSearchResults: backendQueryKey<Tyre[]>({ component, baseUrl: ENV.carBaseURL, endpoint: "/tyres/search" })
};
